import { Component, Input } from '@angular/core';

@Component({
  selector: 'sg-divider',
  templateUrl: './sg-divider.component.html',
  styleUrls: ['./sg-divider.component.scss'],
  standalone: false,
})
export class SgDividerComponent {
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() width: string = '100%';
  @Input() height: string = '100%';
  @Input() color: string = '--sg-stroke-primary';
  @Input() thickness: string = '1px';
  @Input() margin: string;
  @Input() cssClass: string;

  get dividerStyles() {
    const baseStyles = {
      backgroundColor: `var(${this.color})`,
      ...(this.margin && { margin: this.margin }),
    };

    if (this.orientation === 'horizontal') {
      return {
        ...baseStyles,
        width: this.width,
        height: this.thickness,
      };
    } else {
      return {
        ...baseStyles,
        width: this.thickness,
        height: this.height,
      };
    }
  }

  get dividerClasses(): string[] {
    return ['sg-divider', `sg-divider-${this.orientation}`, this.cssClass || ''].filter(Boolean);
  }
}
